import { QuestionModel } from '@/modules/core/domain/interfaces/IFormulary';
import React from 'react';

const Score: React.FC<QuestionModel> = () => {
  return null;
};

export default Score;
